import React, { Component, Fragment } from "react";
import { Cookies } from "react-cookie";
import { Button, Form, Input, message, Typography, Row, Col } from "antd";
import { NumberOutlined, MobileOutlined, LoadingOutlined, ReloadOutlined } from "@ant-design/icons";
import { Constants } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
const { Text } = Typography;

class LoginPage extends Component {
  constructor() {
    super();

    this.state = {
      step: 1,
      countdown: 30,
      canResend: false,
      username: ""
    };

    this.cookies = new Cookies();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  startTimer = () => {
    this.setState({ countdown: 30, canResend: false });
    this.timer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.countdown <= 1) {
          clearInterval(this.timer);
          return { countdown: 0, canResend: true };
        }
        return { countdown: prevState.countdown - 1 };
      });
    }, 1000);
  };

  handleResend = async() => {
    // اینجا API ارسال مجدد کد رو صدا بزنید
    await this.handleLogin({username: this.state.username})
  };
  handleLogin = (values) => {
    this.setState({ submitting: true, username: values.username });

    API.user
      .getToken(values)
      .then((result) => {
        if (result.status) {
          this.setState({ username: values.username, step: 2, submitting: false });
          this.startTimer();
        } else {
          this.setState({ submitting: false });
        }
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleVerify = (values) => {
    this.setState({ submitting: true });
    values.username = this.state.username
    API.user
      .login(values)
      .then((result) => {
        if (result.token) {
          const date = new Date();
          date.setTime(date.getTime() + Constants.expires_in);
          this.cookies.set("AccessToken", result.token, {
            path: "/",
            expires: date,
            domain: window.location.hostname,
          });
          window.location = "/";
        } else {
          this.setState({ submitting: false });
        }
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };
  render() {
    const { username, step, submitting, countdown, canResend } = this.state;

    return (
      <Fragment>
        <img
          src="/images/logo-big.png"
          alt="mizbano"
          width={200}
          height={200}
        />
        <h1>{Resources.login}</h1>
        {step === 1 && (
          <Form initialValues={{ username: username }}
                onFinish={ this.handleLogin}
          >
              <Form.Item name="username" rules={Rules.mobile}>
                <Input
                  type="text"
                  size="large"
                  dir="ltr"
                  suffix={<MobileOutlined />}
                  placeholder={Resources.enterMobile}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  loading={submitting}
                  block
                >
                  {Resources.sendCode}
                </Button>
              </Form.Item>
          
          </Form>
        )}
        {step === 2 && (
          <Form initialValues={{ username: username }} onFinish={this.handleVerify}>
            <Row gutter={24}>
              <Col md={18}>
                <Form.Item name="password" rules={Rules.required}>
                  <Input
                    type="text"
                    size="large"
                    dir="ltr"
                    suffix={<NumberOutlined />}
                    // onPressEnter={this.handleVerify}
                    placeholder={Resources.enterCode}
                  />
                </Form.Item>
              </Col>
              <Col md={6}>
         
                <Form.Item >
                    <Button
                      // type="primary"
                      disabled={!canResend}
                      onClick={this.handleResend}
                      icon={
                        submitting ? (
                          <LoadingOutlined spin /> // آیکون چرخشی
                        ) : (
                          <ReloadOutlined /> // آیکون رفرش معمولی
                        )
                      }
                    >
                      {canResend
                        ? submitting
                          ? "در حال ارسال..."
                          : "ارسال مجدد کد"
                        : `ارسال مجدد بعد از ${countdown} ثانیه`}
                  </Button>
                </Form.Item>

              </Col>
            </Row>
          
           
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={submitting}
                block
              >
                {Resources.enter}
              </Button>
            </Form.Item>
          </Form>
        )}
      </Fragment>
    );
  }
}

export default LoginPage;
